<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, mmModal }">
      <v-btn
        x-large
        elevation="3"
        class="ma-2"
        color="primary"
        v-bind="mmModal"
        v-on="on"
        >Click Me</v-btn
      >
    </template>
    <v-card elevation="3" class="modal-card">
      <v-card-title>
        <h3>Project Overview</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <hr />
      </v-card-title>
      <div class="modal-img">
        <img
          src="@/assets/images/featured-projects/MeterMiser-Main.jpg"
          alt="SDP"
        />
      </div>
      <div class="project-info">
        <h1>MeterMiser Web App</h1>
        <p>
          An IoT-lite application to monitor wifi thermostats and alerts the
          owner via text if any changes have been made that may cost them
          money.<br /><br />Small business owners that operate retail
          storefronts have a lot to do every day. Remembering to turn down/up
          the thermostat often falls to the very bottom of a very long "To Do"
          list. Yet, forgetting this task can cost this small business owner
          hundreds or even thousands of dollars per year depending on the number
          an size of their retail locations. What if there were a way to
          intelligently monitor and alert the small business owner when there
          are opportunities to adjust the thermostat and generate cost savings?
        </p>
        <ul class="details">
          <li><label>Project:</label>Built while at DigitalCrafts Atlanta</li>
          <li><label>Category:</label>Web Development</li>
          <li>
            <label>Project URL:</label
            ><a
              target="_blank"
              href="https://github.com/mcfarland422/MeterMiser_v2"
              ><v-icon>mdi-github</v-icon> View on GitHub</a
            >
          </li>
        </ul>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style lang="scss">
</style>